// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"472":"settings","792":"main"}[chunkId] + "-" + {"472":"9abf2","792":"f7060"}[chunkId] + ".css";
};